import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
import App from './App';
import AppEnglish from './components/english/App';
import reportWebVitals from './reportWebVitals';


// render AppEnglish conditionally based on the pathname
if (window.location.pathname === "/english") {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <AppEnglish />
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
  }
// ReactDOM.render(
//   <React.StrictMode>
//     <Router>
//       <App />
//       <AppEnglish />
//     </Router>
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
